import promos from 'config/promos'
import { PromosProvider } from '@sailogy/shipwright'


const Promos: React.FC = ({ children }) => (
  <PromosProvider promos={promos}>
    {children}
  </PromosProvider>
)

export default Promos
